"use client";

/**
 * Hook for tracking Twitter/X Ads pixel events.
 * Used for conversion tracking on wallet connection.
 */
export function useTwitterPixel() {
  const trackConnectWallet = (walletAddress?: string) => {
    if (typeof window !== "undefined" && window.twq) {
      window.twq("event", "tw-p8cih-qutaa", {
        conversion_id: walletAddress || null,
      });
    }
  };

  return { trackConnectWallet };
}
